import {
  PARTNER_FORM_CHANGE_FIELD,
  PARTNER_SETTINGS_GET_ASYNC,
  PARTNER_SETTINGS_UPDATE_ASYNC,
} from './constants'

const getPartnerSettings = () => ({ type: PARTNER_SETTINGS_GET_ASYNC.INITIATE })
export const getPartnerSettingsSuccess = (data) => ({
  type: PARTNER_SETTINGS_GET_ASYNC.SUCCESS,
  payload: { data },
})
export const getPartnerSettingsError = (error) => ({
  type: PARTNER_SETTINGS_GET_ASYNC.ERROR,
  error,
})
const getPartnerSettingsCancel = () => ({
  type: PARTNER_SETTINGS_GET_ASYNC.CANCEL,
})

const updatePartnerSettings = (data) => ({
  type: PARTNER_SETTINGS_UPDATE_ASYNC.INITIATE,
  payload: { data },
})
export const updatePartnerSettingsSuccess = (form) => ({
  type: PARTNER_SETTINGS_UPDATE_ASYNC.SUCCESS,
  payload: { ...form },
})
export const updatePartnerSettingsError = (error) => ({
  type: PARTNER_SETTINGS_UPDATE_ASYNC.ERROR,
  error,
})
const updatePartnerSettingsCancel = () => ({
  type: PARTNER_SETTINGS_UPDATE_ASYNC.CANCEL,
})

const changeFormValue = (name, value) => ({
  type: PARTNER_FORM_CHANGE_FIELD,
  payload: { name, value },
})

export default {
  // to props
  changeFormValue,
  getPartnerSettings,
  getPartnerSettingsCancel,
  updatePartnerSettings,
  updatePartnerSettingsCancel,
}
